import React, { useEffect, useState } from 'react';
import SocialIconWithTooltip from './SocialIconWithTooltip';
import styles from '../styles';

export default function SocialRow({
    socials = [],
    email,
    emailLabel,
    ariaLabel,
    isExtraSmall = false
}) {
    const [isLargeScreen, setIsLargeScreen] = useState(false);

    useEffect(() => {
        const media = window.matchMedia('(min-width: 900px)');
        const listener = () => setIsLargeScreen(media.matches);

        listener();
        media.addEventListener('change', listener);

        return () => media.removeEventListener('change', listener);
    }, []);

    // tamaños dinámicos
    const socialIconSize = isLargeScreen ? 20 : 24;
    const socialGap = isLargeScreen ? 10 : 12;
    const items = email
        ? [...socials, { name: emailLabel, href: `mailto:${email}` }]
        : socials;

    return (
        <div
            style={{
                ...styles.socialRow,
                flexDirection: isExtraSmall ? 'column' : 'row',
                gap: socialGap,
                alignItems: 'center',  // ❇ Centra verticalmente
                justifyContent: 'center', // ❇ Centra horizontalmente
                flexWrap: 'wrap' // ❇ Permite que bajen a otra línea
            }}
            aria-label={ariaLabel}
        >
            {items.map((item) => (
                <SocialIconWithTooltip
                    key={item.name || item.href}
                    name={item.name}
                    href={item.href}
                    title={item.name}
                    ariaLabel={item.name}
                    style={{
                        ...styles.socialIcon,
                        width: socialIconSize + 10,
                        height: socialIconSize + 10,

                        // Centrado interno del icono
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    size={socialIconSize} // 👈 IMPORTANTE: pasamos el tamaño al icono
                />
            ))}
        </div>
    );
}
